import styled from 'styled-components';

import { Section } from 'src/presentation/components/forms/Layout';

const CompactSection = styled(Section)`
  margin-bottom: 12px;
`;

export default CompactSection;
